module.exports = __webpack_public_path__ + "static/media/example-1.667a3136.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyTurfClub/example-1.jpg
// module id = 212
// module chunks = 0